import React, { createContext, useContext, useState, useEffect } from 'react';

const KitchenCartContext = createContext();

export const useKitchenCart = () => useContext(KitchenCartContext);

export const KitchenCartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState([]);
  const [totalPrice, setTotalPrice] = useState(0);
  
  useEffect(() => {
    // Calculate total price whenever cart items change
    // Kitchen items have price in standard currency units (not cents)
    const newTotal = cartItems.reduce(
      (sum, item) => sum + (item.price * item.quantity),
      0
    );
    setTotalPrice(newTotal);
  }, [cartItems]);

  const addToCart = (item) => {
    setCartItems(prevItems => {
      // Check if item already exists in cart (using uuid for kitchen items)
      const existingItemIndex = prevItems.findIndex(cartItem => cartItem.uuid === item.uuid);
      
      if (existingItemIndex >= 0) {
        // Item exists, increase quantity
        const updatedItems = [...prevItems];
        updatedItems[existingItemIndex] = {
          ...updatedItems[existingItemIndex],
          quantity: updatedItems[existingItemIndex].quantity + 1
        };
        return updatedItems;
      } else {
        // Item doesn't exist, add new item with quantity 1
        return [...prevItems, { ...item, quantity: 1 }];
      }
    });
  };

  const removeFromCart = (itemUuid) => {
    setCartItems(prevItems => prevItems.filter(item => item.uuid !== itemUuid));
  };

  const updateQuantity = (itemUuid, quantity) => {
    if (quantity <= 0) {
      removeFromCart(itemUuid);
      return;
    }
    
    setCartItems(prevItems =>
      prevItems.map(item =>
        item.uuid === itemUuid ? { ...item, quantity } : item
      )
    );
  };

  const clearCart = () => {
    setCartItems([]);
  };

  return (
    <KitchenCartContext.Provider
      value={{
        cartItems,
        totalPrice,
        addToCart,
        removeFromCart,
        updateQuantity,
        clearCart
      }}
    >
      {children}
    </KitchenCartContext.Provider>
  );
};
